import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { useUserContext } from "./UserContext";
import axios, { AxiosResponse } from "axios";
import toast from "react-hot-toast";
import { baseServiceUrl, proctorServiceURL, urls } from "../environment";
import { QuestionBankTypes } from "../interfaces/question.interface";
import {
  CancellationReasonTypes,
  CreateScrutinyInterface,
  FaceVerificationPayloadType,
  GetScrutinyListInterface,
} from "../interfaces/exams.interface";
import {
  decryptAES256CBC,
  decryptAES256CBC2,
  encryptWithFixedKey,
  isCameraAvailable,
} from "../utils";
import { TypeContactFormData } from "../views/Main/Contact";
import { useLocation } from "react-router-dom";
import useExamStores from "../stores/useExamStores";
import useUserStore from "../stores/useUserStores";

//   import { DomainTypes, DomainTypesMain } from "../interfaces/domain.interface";
//   import { UserContext, useUserContext } from "./UserContext";
//   import axios from "axios";
//   import { baseServiceUrl, urls } from "../environment";
//   import toast from "react-hot-toast";

type ExamContextProviderProps = {
  children: ReactNode;
};
export type ExamContextProps = {
  
  generateProctorToken: ({
    payload,
    successCallback,
    errorCallback,
  }: {
    payload: any;
    successCallback?: (args?: any) => void;
    errorCallback?: (args?: any) => void;
  }) => Promise<void>;
  ApplyContactForm: ({
    payload,
    successCallback,
    errorCallback,
  }: {
    payload: TypeContactFormData;
    successCallback?: (args?: any) => void;
    errorCallback?: (args?: any) => void;
    finallyCallback?: (args?: any) => void;
  }) => Promise<any>;
  proctorSendImage: ({
    payload,
    successCallback,
    errorCallback,
  }: {
    payload: any;
    successCallback?: (args?: any) => void;
    errorCallback?: (args?: any) => void;
  }) => Promise<void>;
  

  

  getCancelledExamHandler: ({
    payload,
    successCallback,
    errorCallback,
  }: {
    payload: any;
    successCallback?: (args?: any) => void;
    errorCallback?: (args?: any) => void;
  }) => Promise<void>;

  ApplyScrutinyHandler: ({
    payload,
    successCallback,
    errorCallback,
    finallyCallback,
    notFoundCallback,
  }: {
    payload: FaceVerificationPayloadType;
    successCallback?: () => void;
    errorCallback?: () => void;
    finallyCallback?: () => void;
    notFoundCallback?: () => void;
  }) => Promise<any>;
};


const  useExamServices=():ExamContextProps => {
  const userDetails: any = useUserStore();
  const {setCameraFound,proctorAuthToken,setProctorAuthToken} = useExamStores();
  // const [faceVerfied, setFaceVerified] = useState<boolean>(false);
  // const [CameraFound, setCameraFound] = useState<boolean>(false);

  // const [proctorAuthToken, setProctorAuthToken] = useState<string>("");

  const ApplyScrutinyHandler = async ({
    payload,
    successCallback,
    errorCallback,
    finallyCallback,
    notFoundCallback,
  }: {
    payload: FaceVerificationPayloadType;
    successCallback?: () => void;
    errorCallback?: () => void;
    finallyCallback?: () => void;
    notFoundCallback?: () => void;
  }) => {
    try {
      userDetails.setLoading(true);
      const Epayload = encryptWithFixedKey(payload);
      const response = await axios.post(
        baseServiceUrl + urls.faceVerificationURL,
        Epayload,
        {
          headers: {
            Authorization: "Bearer " + userDetails.token,
          },
        }
      );

      if (response?.data) {
        const rawResponse = await decryptAES256CBC2(
          response.data?.response,
          btoa(payload.encryption_key)
        );
        const responsedData = JSON.parse(rawResponse);

        if (responsedData && responsedData?.all_match) {
          successCallback?.();
        } else {
          notFoundCallback?.();
        }
      }
    } catch (error) {
      errorCallback?.();
      userDetails.setLoading(false);
      toast.error("something went wrong");
    } finally {
      finallyCallback?.();
      userDetails.setLoading(false);
    }
  };

  // const proctorSendImage = async ({
  //   payload,
  //   successCallback,
  //   errorCallback,
  // }: {
  //   payload: any;
  //   successCallback?: (args?: any) => void;
  //   errorCallback?: (args?: any) => void;
  // }) => {
  //   try {
  //     if (!proctorAuthToken) return;
  //     const formData = new FormData();
  //     formData.append("image", payload.image, `photo_${Date.now()}.jpg`);
  //     formData.append("exam_id", payload.exam_id);
  //     formData.append("user_id", payload.user_id);
  //     const response = await axios.post(
  //       proctorServiceURL + urls.processProctorFrame,
  //       formData,
  //       {
  //         headers: {
  //           "Exam-Token": proctorAuthToken,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     successCallback?.();
  //
  //   } catch (error) {
  //
  //     errorCallback?.();
  //   }
  // };

  const proctorSendImage = async ({
    payload,
    successCallback,
    errorCallback,
  }: {
    payload: {
      image: File | Blob;
      exam_id: string;
      user_id: string;
    };
    successCallback?: (args?: any) => void;
    errorCallback?: (args?: any) => void;
  }) => {
    try {
      if (!proctorAuthToken) return;

      const formData = new FormData();
      formData.append("image", payload.image, `photo_${Date.now()}.jpg`);
      formData.append("exam_id", payload.exam_id);
      formData.append("user_id", payload.user_id);

      const response = await fetch(
        `${proctorServiceURL}${urls.processProctorFrame}`,
        {
          method: "POST",
          headers: {
            "Exam-Token": proctorAuthToken,
          },
          body: formData,
        }
      );

      if (response.ok) {
        const responseDetails = await response.json();

        if (responseDetails) successCallback?.(responseDetails);
      }
    } catch (error) {
      errorCallback?.(error);
    }
  };

  const ApplyContactForm = async ({
    payload,
    successCallback,
    errorCallback,
  }: {
    payload: TypeContactFormData;
    successCallback?: (args?: any) => void;
    errorCallback?: (args?: any) => void;
    finallyCallback?: (args?: any) => void;
  }) => {
    try {
      userDetails.setLoading(true);
      const response = await axios.post(
        baseServiceUrl + urls.contactUs,
        payload,
        {
          headers: {
            Authorization: "Bearer " + userDetails.token,
          },
        }
      );
      successCallback?.(response?.data);
    } catch (error) {
      errorCallback?.();
      userDetails.setLoading(false);
    } finally {
      userDetails.setLoading(false);
    }
  };

  const generateProctorToken = async ({
    payload,
    successCallback,
    errorCallback,
  }: {
    payload: any;
    successCallback?: (args?: any) => void;
    errorCallback?: (args?: any) => void;
  }) => {
    try {
      userDetails.setLoading(true);
      const response = await axios.post(
        baseServiceUrl + urls.proctorGenerateToken,
        payload
      );
      if (response?.data) {
        successCallback?.(response?.data);
      }
    } catch (error) {
      errorCallback?.();
    } finally {
      userDetails.setLoading(false);
    }
  };

  const getCancelledExamHandler = async ({
    payload,
    successCallback,
    errorCallback,
  }: {
    payload: any;
    successCallback?: (args?: any) => void;
    errorCallback?: (args?: any) => void;
  }) => {
    try {
      userDetails.setLoading(true);
      const response = await axios.post(
        baseServiceUrl + urls.cancelExamList,
        payload,
        {
          headers: {
            Authorization: "Bearer " + userDetails.token,
          },
        }
      );
      if (response?.data) {
        successCallback?.(response?.data);
      }
    } catch (error) {
      errorCallback?.();
    } finally {
      userDetails.setLoading(false);
    }
  };

  useEffect(() => {
    if (userDetails?.userdetail) {
      (async () => {
        const cameraAvilable = await isCameraAvailable();
        setCameraFound(cameraAvilable);
      })();
    }
  }, [userDetails?.userdetail]);

  return {
        getCancelledExamHandler,

        generateProctorToken,
        
        
        ApplyScrutinyHandler,
        ApplyContactForm,
        proctorSendImage,
  }
      
};



export default useExamServices